import React, { useContext, useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { NavLink } from 'react-router-dom'
import { ROUTE_STRINGS } from 'Utils/Constants'
import { CoffeeWebWhiteLogoMask } from 'Assets/Icons'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'

const FreeMenubar = ({ guestUserMenus }) => {
  const location = useLocation()
  const { isLoading } = useContext(CoffeeWebContext)
  const dropdownRef = useRef(null)

  // commented for Explore Dropdown

  // const [isExploreOpen, setIsExploreOpen] = useState(false)

  // useEffect(() => {
  //   const handleOutsideClick = (event) => {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setIsExploreOpen(false)
  //     }
  //   }

  //   document.addEventListener('click', handleOutsideClick)

  //   return () => document.removeEventListener('click', handleOutsideClick)
  // }, [])

  // useEffect(() => {
  //   // Close the dropdown when the route changes
  //   setIsExploreOpen(false)
  // }, [location.pathname])

  /* eslint-disable prefer-template */
  const transformMenuUrl = (url) => '/' + url

  // const parentMenuWithSubmenus = guestUserMenus?.find((menu) => menu.subMenuModels?.length > 0) // commented for Explore Dropdown

  return (
    <>
      <div className={`post_header ${isLoading ? 'is-loading' : ''}`} data-testid="menu-main-container">
        <div className="" id="navbar-main" data-testid="navbar-main-container">
          <div>
            <div aria-controls="basic-navbar-nav" />
            <div id="basic-navbar-nav" data-testid="basic-navbar-container">
              <ul className="navbar-nav" data-testid="navbar-ul-container">
                {guestUserMenus?.length &&
                  guestUserMenus?.map((ele, index) => (
                    <div key={index}>
                      {ele.isFreeMenuWebDisplayEnable === true && ele.isLaunch === true && ele.menuUrl !== null && (
                        <li className="nav-item1 menucolor1" id="navitem" data-testid="navbar-li-container">
                          <NavLink activeClassName="active_nav-link1" exact to={ele.menuUrl === 'CoffeeQuotes' ? ROUTE_STRINGS.guestCoffeeQuotes : transformMenuUrl(ele.menuUrl)} className="nav-link1 nav-link-ltr">
                            <div className="menu-name-container" data-testid="menu-name-container">
                              {ele.menuIcon && <img src={ele.menuUrl === 'aboutUs' && !location.pathname?.includes(ROUTE_STRINGS.aboutUs) ? CoffeeWebWhiteLogoMask : ele?.menuIcon} alt="menu-image" className="menu-icon" />}
                              {ele.menuName}
                            </div>
                          </NavLink>
                        </li>
                      )}
                    </div>
                  ))}

                {/* Coffee Games Static Menu */}
                {/* <li className="nav-item1 menucolor1" id="navitem" data-testid="navbar-li-container">
                  <NavLink activeClassName="active_nav-link1" exact to={ROUTE_STRINGS.guestCoffeeGames} className="nav-link1 nav-link-ltr"></NavLink>
                </li> */}

                {/* Commented for Explore Dropdown Menu */}
                {/* Explore Dropdown Menu */}
                {/* {parentMenuWithSubmenus?.menuName && (
                  <li
                    className="nav-item1 menucolor1 dropdown-li-explore"
                    ref={dropdownRef}
                    onClick={(e) => {
                      e.stopPropagation()
                      setIsExploreOpen((prev) => !prev)
                    }}
                  >
                    <div className="nav-link1 dropdown-toggle" data-testid="explore-menu">
                      {parentMenuWithSubmenus?.menuName}
                      <i className="pi pi-bars"></i>
                    </div>
                    {isExploreOpen && (
                      <ul className="dropdown-menu-ul" data-testid="dropdown-menus">
                        {parentMenuWithSubmenus?.subMenuModels?.map((menu) => (
                          <li key={menu.id}>
                            <NavLink exact to={transformMenuUrl(menu.menuUrl)} className="dropdown-item-navLink" onClick={() => setIsExploreOpen(false)}>
                              <div className="menu-dropdown-content">
                                {menu.menuIcon && <img src={menu.menuIcon} alt="menu-image" className="menu-icon" />}
                                {menu.menuName}
                              </div>
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                )} */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default FreeMenubar
